import React, { lazy, Suspense } from "react";
import { PAGE } from "./urls";
import { Box, CircularProgress } from "@mui/material";
import Layout from "../components/layout";
import ErrorBoundary from "../components/errorboundary";

const Home = lazy(() => import("../pages/home-page"));
const ServicesPage = lazy(() => import("../pages/service-page"));
const AboutPage = lazy(() => import("../pages/about-page"));
const ContactPage = lazy(() => import("../pages/contact-page"));
const NotFoundPage = lazy(() => import("../pages/not-found-page"));

const PageLoader = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
    }}
  >
    <CircularProgress sx={{ color: "#d4a045" }} />
  </Box>
);

const withLayout = (Component: React.ComponentType) => (
  <ErrorBoundary>
    <Suspense fallback={<PageLoader />}>
      <Layout>
        <Component />
      </Layout>
    </Suspense>
  </ErrorBoundary>
);

export interface RouteConfig {
  key: string;
  label: string;
  path: string;
  element: React.ReactElement;
  hasDropdown?: boolean;
}

export const webRoute: RouteConfig[] = [
  {
    key: "Home",
    label: "Home",
    path: PAGE.DEFAULT,
    element: withLayout(Home),
  },
  {
    key: "AboutUs",
    label: "About Us",
    path: PAGE.ABOUTPAGE,
    element: withLayout(AboutPage),
  },
  {
    key: "Services",
    label: "Services",
    path: PAGE.SERVICESPAGE,
    element: withLayout(ServicesPage),
    hasDropdown: true,
  },
  {
    key: "Contact",
    label: "Contact",
    path: PAGE.CONTACTPAGE,
    element: withLayout(ContactPage),
  },
  {
    key: "NotFound",
    label: "404",
    path: PAGE.NOTFOUND,
    element: (
      <ErrorBoundary>
        <Suspense fallback={<PageLoader />}>
          <NotFoundPage />
        </Suspense>
      </ErrorBoundary>
    ),
  },
];
